import moment from 'moment/moment';
import { UiCalendarPickerType } from '@enums/shared.enum';
import { OnRangeSelectedResult, UiDatetimeRangePickerModel } from '@ui';
import { ArchiveStatus } from '@models/archive.model';

export namespace ArchiveStatsModels {

  import CustomUnit = UiDatetimeRangePickerModel.CustomUnit;

  export interface Document {
    _id: string;
    cameraId: string;
    edgeId: string;
    name: string;
    sessionId: string;
    start: number,
    end: number,
    status: number,
    local: boolean,
    cloud: boolean,
    orgId: string,
    videoFormat: string,
    mp4PartFilename: string,
    createdAt: number,
    archiveId: string,
    done: boolean,
    duration: number,
    duration_ms: number,
    filename: string,
    progress: number,
    timestamp: number;
    updatedAt: number;
    uploadDone: boolean,
    uploadProgress: number,
    md5Sum: string;
    jobStats: JobStat;
    files: File;
  }

  export interface JobStat {
    retryOnFailed: number;
    preemptedCount: number;
    end: number;
    duration: number;
    start: number;
  }

  export interface Video {
    start: number;
    end: number;
    mp4Path: string;
    hlsPath: string;
    md5: string;
  }

  export interface File {
    type: string,
    videos: Video[]
  }

  const dateRangeInitial = {
    start: moment()
      .subtract(1, 'week')
      .toString(),
    end: moment()
      .toString(),
  };

  export const defaultDateRange: OnRangeSelectedResult = {
    absolute: dateRangeInitial,
    type: UiCalendarPickerType.RELATIVE,
    relative: { unit: CustomUnit.weeks, value: 1 },
  };

  export interface RequestFilter {
    dateRange: OnRangeSelectedResult;
    status: ArchiveStatus[];
    orgId: string;
  }

  export const defaultRequestFilter: RequestFilter = {
    dateRange: defaultDateRange,
    status: [],
    orgId: null,
  };

  export const PAGE_LIMIT = 30;

}
